<template>
  <div class="component-content configuration-groupset">
    <div class="component-content-scroll">
      <div class="component-content-title mb-3">Select your groupset</div>
      <b-tabs content-class="mt-3" v-model="currentTab">
        <b-tab
          title="groupset"
          active
          v-if="typeof this.components.groupset != 'undefined'"
        >
          <div>
            <option-list
              :options="groupsetInput"
              :measures="measures"
              :measureLabel="'Set groupset length'"
              :targetMeasure="this.measures.handlebars"
              :target="this.results.groupset"
              :inputName="'groupset'"
              :results="results"
              :electronicMode="electronicMode"
              v-on:target-updated="updateGroupset"
              v-on:update-measures="setMeasure"
              v-if="this.components.groupset"
            ></option-list>
          </div>
        </b-tab>
        <b-tab
          title="crankset"
          v-if="typeof this.components.crank != 'undefined'"
        >
          <div>
            <keep-alive>
              <option-list
                :options="(this.cranksetList?.length > 0 && this.cranksetList) || this.cranksetInput"
                :target="this.results.crankset"
                :inputName="'crankset'"
                :electronicMode="electronicMode"
                v-on:target-updated="updateCrankset"
                v-if="this.components.crank"
              ></option-list>
            </keep-alive>
          </div>
        </b-tab>
        <b-tab title="rings" v-if="typeof this.components.rings != 'undefined'">
          <div>
            <option-list
              :options="cranksetInput"
              :target="this.results.rings"
              :inputName="'rings'"
              v-on:target-updated="updateRings"
            ></option-list>
          </div>
        </b-tab>
        <b-tab
          title="cassette"
          v-if="typeof this.components.cassette != 'undefined'"
        >
          <div>
            <option-list
              :options="cranksetInput"
              :target="this.results.cassette"
              :inputName="'cassette'"
              v-on:target-updated="updateCassette"
              v-if="this.components.cassette"
            ></option-list>
          </div>
        </b-tab>
      </b-tabs>
    </div>
    <div class="buttonset">
      <button class="btn btn-outline-dark back-button" v-on:click="goBack">
        back
      </button>
      <finish-configuration-button
        v-if="canFinishConfiguration()"
        v-on:finish-configuration="finishConfiguration"
       ></finish-configuration-button>
      <button class="btn btn-outline-dark next-button" v-on:click="goNext">
        next
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import OptionList from "../../shared/optionList.vue";
import FinishConfigurationButton from './finish-configuration-button.vue';

Vue.component("finish-configuration-button", FinishConfigurationButton);

export default {
  name: "configuration-groupset",
  data() {
    return {
      currentTab: 0,
      totalTabs: 2,
      cranksetList: null,
    };
  },
  components: {
    OptionList,
  },
  props: [
    "configuratorSteps",
    "currentStep",
    "results",
    "components",
    "measures",
    "relatedCrankset",
    "electronicMode",
  ],
  methods: {
    goNext: function () {
      if (this.results.groupset == null) {
        this.$emit("set-error", "Select a groupset");
        return;
      }
      if (this.currentTab == 1 && this.results.crankset == null) {
        this.$emit("set-error", "Select a crankset");
        return;
      }

      // if (this.results.groupset.measures != "" && typeof this.results.groupset.measure == "undefined"){
      //   this.$emit('set-error', 'Please select a crankset measure');
      //   return;
      // }

      if (this.currentTab < this.totalTabs - 1) {
        this.currentTab++;
      } else {
        this.$emit("go-next");
      }
    },
    goBack: function () {
      if (this.currentTab > 0) {
        this.currentTab--;
      } else {
        this.$emit("go-back");
      }
    },
    updateGroupset: function (e) {
      let cr = JSON.stringify(this.components.crank);
      /* if (this.relatedCrankset!=null){
        document.querySelector('.option-' + this.relatedCrankset.id).classList.add('active');
      } */
      this.groupsetInput = e;
      if (e.measures == "") {
        this.setMeasure(null);
      }

      // Se il groupset selezionato è "no option", auto-seleziona "no option" per il crankset
      if (e.id == -1) {
        // Trova l'opzione "no option" per il crankset
        const noOptionCrankset = this.components.crank[0].find(item => item.id == -1);
        if (noOptionCrankset) {
          // Auto-seleziona "no option" per il crankset
          this.$emit("set-crankset", noOptionCrankset);
        }
        this.cranksetList = null;
      } else {
        if (this.cranksetList == null) {
          this.cranksetList = this.components.crank[0];
        }
      }
    },
    updateCrankset: function (e) {
      this.cranksetInput = e;
      /*
      if (this.relatedCrankset!=null) {
        document.querySelector('.option-' + this.relatedCrankset.id).classList.add('active');
        document.querySelector('.option-' + this.relatedCrankset.id + ' label').classList.add('active');
        let crid = this.relatedCrankset.id;
        setTimeout(function() {
          document.querySelector('.option-'+ crid + ' label').classList.add('related-active');
        }, 10);
      }
      */
    },
    setMeasure: function (measure) {
      this.measuresInput = measure;
    },
    getMeasure: function () {
      if (this.results.groupset != null) {
        return this.results.groupset.measure;
      }
      return null;
    },
    updateRings: function (e) {
      this.ringsInput = e;
    },
    updateCassette: function (e) {
      this.cassetteInput = e;
    },
    canFinishConfiguration: function() {
// if fork is present, we need to check if the fork is selected and has a colour
        if (this.components.fork?.length > 0) 
        {
          return (
          this.results.frame !== null &&
          this.results.frame !== undefined &&
          this.results.colour !== null &&
          this.results.colour !== undefined &&
          this.results.fork !== null &&
          this.results.fork !== undefined
          );
        }
        else
        {
          // no fork, so we can finish configuration
          return (
            this.results.frame !== null &&
            this.results.frame !== undefined &&
            this.results.colour !== null &&
            this.results.colour !== undefined
          );
        }
    },
    finishConfiguration: function() {
        this.$emit("finish-configuration");
    },
  },
  computed: {
    groupsetInput: {
      get: function () {
        var groupsetLists;
        if (this.results.fork != null && this.results.fork.is_electronic == 1) {
          groupsetLists = this.components.groupset[0].filter((item) => {
            return item.is_electronic == 1;
          });
        } else {
          groupsetLists = this.components.groupset[0];
        }
        // groupsetLists = this.components.groupset[0];
        return groupsetLists;
      },
      set: function (e) {
        this.$emit("set-groupset", e);
      },
    },
    measuresInput: {
      get: function () {
        if (
          this.results.groupset == null ||
          typeof this.results.groupset.measure == "undefined"
        ) {
          return null;
        }
        return this.results.groupset.measure;
      },
      set: function (e) {
        this.$emit("set-measure", "groupset", e);
      },
    },
    cranksetInput: {
      get: function () {
        var cranksetLists;

        // Se il groupset selezionato è "no option", mostra solo l'opzione "no option" per il crankset
        if (this.results.groupset && this.results.groupset.id == -1) {
          // Trova l'opzione "no option" per il crankset
          const noOptionCrankset = this.components.crank[0].find(item => item.id == -1);
          return noOptionCrankset ? [noOptionCrankset] : [];
        }

        if (this.relatedCrankset && this.relatedCrankset.id !== undefined) {
          cranksetLists = this.components.crank[0].filter((item) => {
            return (
              this.relatedCrankset.id == item.id ||
              item.id == 81 ||
              item.id == 104
            );
          });
        } else {
          cranksetLists = this.components.crank[0];
        }
        return cranksetLists;
      },
      set: function (e) {
        this.$emit("set-crankset", e);
      },
    },
    ringsInput: {
      get: function () {
        return this.components.groupset[0];
      },
      set: function (e) {
        this.$emit("set-rings", e);
      },
    },
    cassetteInput: {
      get: function () {
        return this.components.groupset[0];
      },
      set: function (e) {
        this.$emit("set-cassette", e);
      },
    },
  },
  created() {
    setTimeout(() => {
      let tabs = document.querySelectorAll(".nav-tabs .nav-item");
      this.currentTab = 0;
      this.totalTabs = tabs.length;
    }, 100);
  },
  watch: {
    relatedCrankset: {
      handler(newValue) {
        if (this.relatedCrankset && this.relatedCrankset.id !== undefined) {
          this.cranksetList = this.components.crank[0].filter((item) => {
            return (
              this.relatedCrankset.id == item.id ||
              item.id == 81 ||
              item.id == 104
            );
          });
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
